__turbopack_context__.v({
  "className": "CjbrRq_className",
  "variable": "CjbrRq_variable",
});
